export const PendingTransactionConfirmedDeletedWebSocketHandlerName = 'ReceiveConfirmedDeletedPendingTransaction';